export default __webpack_public_path__ + "static/media/landing-page-bg.c1520b27.jpg";